import type { AvailabilityConfig } from '../types';

const DAY_MAP: Record<string, number> = {
  sun: 0,
  sunday: 0,
  mon: 1,
  monday: 1,
  tue: 2,
  tues: 2,
  tuesday: 2,
  wed: 3,
  weds: 3,
  wednesday: 3,
  thu: 4,
  thur: 4,
  thurs: 4,
  thursday: 4,
  fri: 5,
  friday: 5,
  sat: 6,
  saturday: 6,
};

function getZonedDate(timeZone?: string) {
  if (!timeZone) return new Date();
  try {
    return new Date(new Date().toLocaleString('en-US', { timeZone }));
  } catch {
    return new Date();
  }
}

export function isWithinAvailability(config?: AvailabilityConfig) {
  if (!config || config.enabled === false) return true;
  const zoned = getZonedDate(config.timezone);
  const dayIndex = zoned.getDay();
  const hour = zoned.getHours();

  if (config.days && config.days.length > 0) {
    const allowed = config.days
      .map(day => DAY_MAP[String(day).toLowerCase()])
      .filter(d => typeof d === 'number');
    if (allowed.length > 0 && !allowed.includes(dayIndex)) return false;
  }

  const startHour = typeof config.startHour === 'number' ? config.startHour : 0;
  const endHour = typeof config.endHour === 'number' ? config.endHour : 24;

  if (startHour === endHour) return true;
  if (startHour < endHour) return hour >= startHour && hour < endHour;
  return hour >= startHour || hour < endHour;
}
